import {
  FETCH_DEPOSIT_REQUEST,
  FETCH_DEPOSIT_SUCCESS,
  FETCH_DEPOSIT_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  error: null,
  isFetching: false,
  list: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_DEPOSIT_REQUEST:
      return {
        ...state,
        error: null,
        isFetching: true,
      }

    case FETCH_DEPOSIT_SUCCESS:
      return {
        ...state,
        error: null,
        isFetching: false,
        list: action.payload,
      }

    case FETCH_DEPOSIT_ERROR:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      }

    default:
      return state
  }
}
